import { Box, Flex, Grid, GridItem, HStack, Stack, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import APButton from "../../../components/APButton";
import APResultDialog from "../../../custom/APResultDialog";
import { Checkmark, Cross } from "../../../components/APAssetAtlas";
import { VocabWord } from "../../../VocabModel";
import { useVocabIntl } from "../../../hooks/useVocabTranslation";

interface CorrectnessModalProps {
  open: boolean;
  correctWords: VocabWord[];
  wrongWords: VocabWord[];
  passedWords: VocabWord[];
  onRestart: (wrongWords: VocabWord[]) => void;
  onQuit: () => void;
}

export default function CorrectnessModal(props: CorrectnessModalProps) {
  const { open, onRestart, onQuit, correctWords, wrongWords, passedWords } =
    props;
  const [failWords, setFailWords] = useState<VocabWord[]>([]);
  const { getFormattedString, APFormattedMessage } = useVocabIntl();

  useEffect(() => {
    let words = wrongWords;

    // passedWords.forEach((wd) => {
    //   words =
    //     words.findIndex((wordItem) => wordItem.word === wd.word) === -1
    //       ? words.concat([wd])
    //       : words;
    // });
    setFailWords(words);
  }, [wrongWords, passedWords]);

  return (
    <APResultDialog
      preventCloseOnEsc
      open={open}
      title={<APFormattedMessage id={"recap-modal-heading"} />}
      footer={
        <Box
          sx={{
            display: "flex",
            columnGap: 2,
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <APButton size={"md"} colorScheme="secondary" variant={"outline"} disabled={!wrongWords.length}
                    onClick={() => onRestart(wrongWords)}
                    aria-label={getFormattedString("aria-label-restart-button")}>
            <APFormattedMessage id={"restart-button"} />
          </APButton>
          <APButton size={"md"}
                    onClick={onQuit}
                    aria-label={getFormattedString("aria-label-quit-button")}>
            <APFormattedMessage id={"quit-button"} />
          </APButton>
        </Box>
      }
    >
      <Box padding={"0.5rem 1rem"} bg={"bg"} border={"2px solid"}
           width={["calc(100% - 1.5rem)", "calc(100% - 2rem)", "calc(100% - 3rem)"]}
           borderColor={"lightGray.500"}
           borderRadius={"md"}>
        <Flex overflowY={"auto"} paddingX={"0.25rem"} marginX={"-0.5rem"}
              maxHeight={["40vh", "40vh", "40vh"]}
              minHeight={"8rem"} width={"calc(100% + 1rem)"}>
          <Grid templateColumns={`repeat(2, 1fr)`} gap={2} width={"100%"}>
            <GridItem>
              <Stack spacing={0.5}>
                <Box
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  <APFormattedMessage id={"successful-words"} />
                </Box>
                {correctWords.map((wordItem, index) => {
                  return (
                    <HStack
                      w="100%"
                      className="word-item"
                      key={index}
                      spacing={0.5}
                      alignItems="center"
                    >
                      <Box sx={{ color: "success" }}>
                        <Checkmark />
                      </Box>
                      <Text>{wordItem.label}</Text>
                    </HStack>
                  );
                })}
              </Stack>
            </GridItem>
            <GridItem>
              <Stack spacing={0.5}>
                <Box
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  <APFormattedMessage id={"rework-words"} />
                </Box>

                {failWords.map((wordItem, index) => {
                  return (
                    <HStack
                      w="100%"
                      className="word-item"
                      key={index}
                      spacing={0.5}
                      alignItems="center"
                    >
                      <Box sx={{ color: "error" }}>
                        <Cross />
                      </Box>
                      <Text>{wordItem.label}</Text>
                    </HStack>
                  );
                })}
              </Stack>
            </GridItem>
          </Grid>
        </Flex>
      </Box>
    </APResultDialog>
  );
}
